import { FC } from "react";
import { IconButton } from "@mui/material";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";

import { SortDirection } from "@framework/types-collection";

export interface ISortButtonProps {
  isActive?: boolean;
  direction?: SortDirection | null;
  onClick: () => void;
  width?: number;
  height?: number;
}

export const SortButton: FC<ISortButtonProps> = props => {
  const { direction, isActive, onClick, width = 20, height = 20 } = props;

  return (
    <IconButton
      size="small"
      onClick={onClick}
      color={isActive ? "primary" : "default"}
      sx={{ ml: 0.5, svg: { width, height } }}
    >
      {isActive && direction === SortDirection.asc ? (
        <ArrowUpward width={width} height={height} sx={{ width, height }} />
      ) : (
        <ArrowDownward width={width} height={height} sx={{ width, height }} />
      )}
    </IconButton>
  );
};
